import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener, Input } from '@angular/core';

import { gsap } from 'gsap';

import { NavbarItem } from '@common/models/navbar-item';

@Component({
    selector: 'aa-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: [
        './navbar.component.scss'
    ],
    standalone: false
})
export class NavbarComponent implements OnInit, AfterViewInit
{
    @ViewChild('menuItemsZone', { static: true }) itemsZone: ElementRef;
    @ViewChild('menuItemsContainer', { static: true }) itemsContainer: ElementRef;
    @Input() navbarItems: NavbarItem[];
    public containerHeight: number;
    public marginTop: number = 0;
    public isScrollUpDisabled: boolean = false;
    public isScrollDownDisabled: boolean = false;
    private itemHeight: number;
    private zoneHeight: number;
    private minMarginTop: number = 0;
    private maxMarginTop: number = 0;
    private step: number;

    constructor ()
    {
        this.itemHeight = parseInt(getComputedStyle(document.documentElement)
            .getPropertyValue('--left-navbar-item-height'), 10);
        this.step = this.itemHeight / 2;
    }

    ngOnInit ()
    {
        this.calculateDimensions();
    }

    ngAfterViewInit ()
    {
        this.calculateDimensions();
    }

    private calculateDimensions ()
    {
        const firstItem = this.itemsContainer.nativeElement.querySelector('.navbar-item');
        if (!(!firstItem || !this.navbarItems || this.navbarItems.length === 0)) {
            this.itemHeight = firstItem.getBoundingClientRect().height;
            this.step = this.itemHeight / 2
        };
        
        this.containerHeight = this.itemHeight * this.navbarItems.length;
        this.zoneHeight = this.itemsZone.nativeElement.getBoundingClientRect().height;
        this.minMarginTop = -1 * (this.containerHeight - this.zoneHeight);

        if (this.marginTop < this.minMarginTop) {
            this.marginTop = Math.min(this.minMarginTop, this.maxMarginTop);
            gsap.timeline()
                .to(this.itemsContainer.nativeElement, { duration: 0.3, css: { marginTop: this.marginTop }, ease: 'sine' });
        }

        this.isScrollUpDisabled = this.marginTop >= this.maxMarginTop;
        this.isScrollDownDisabled = this.marginTop <= this.minMarginTop;
    }

    // Chromium (Chrom, Edge)
    @HostListener('mousewheel', ['$event'])
    onMouseWheelChromium (event: WheelEvent)
    {
        this.mouseWheelFunc(event.deltaY);
    }

    // Webkit (FF)
    @HostListener('DOMMouseScroll', ['$event'])
    onMouseWheelFirefox (event: any)
    {
        this.mouseWheelFunc(event.detail);
    }

    // Window resize handler
    @HostListener('window:resize', ['$event'])
    onWindowResize (event: any)
    {
        // Recalculate dimensions when window is resized
        this.calculateDimensions();
    }

    onScrollUp ()
    {
        this.scrollUp();
    }

    onScrollDown ()
    {
        this.scrollDown();
    }

    private mouseWheelFunc (direction: number)
    {
        if (direction > 0)
        {
            this.scrollDown();
        }
        else if (direction < 0)
        {
            this.scrollUp();
        }
    }

    private scrollUp ()
    {
        if (!this.isScrollUpDisabled)
        {
            this.slide(1);
        }
    }

    private scrollDown ()
    {
        if (!this.isScrollDownDisabled)
        {
            this.slide(-1);
        }
    }

    private slide (coeff: number): void
    {
        this.marginTop += (coeff * this.step);

        this.isScrollUpDisabled = this.marginTop >= this.maxMarginTop;
        this.isScrollDownDisabled = this.marginTop <= this.minMarginTop;

        gsap.timeline()
            .to(this.itemsContainer.nativeElement, { duration: 0.3, css: { marginTop: this.marginTop }, ease: 'sine' });
    }
}
